import services from 'services/services';
import * as types from '../types';

// Import helpers
import { checkFetchErrors } from '../helpers_actions/convert_helpers';

// ******************** FETCH ASSET DETAILS TO EDIT ********************
export const fetchAssetDetails = (id) => async (dispatch) => {
	try {
		// Dispatch a loading action
		dispatch({
			type: types.FETCH_ASSET_DETAILS_LOADING,
			payload: true
		});

		const { data } = await services.get(
			`/assets/${id}/details?with_metadata=1`
		);

		// Dispatch an action with data
		dispatch({
			type: types.FETCH_ASSET_DETAILS_SUCCESS,
			payload: data
		});
	} catch (error) {
		dispatch({
			type: types.FETCH_ASSET_DETAILS_ERROR,
			payload: checkFetchErrors(error)
		});
	}
};
